// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  structureId: __t.u64().primaryKey().name("structure_id"),
  owner: __t.identity(),
  targetSpawnId: __t.u64().name("target_spawn_id"),
  concentration: __t.f32(),
  storedQty: __t.f32().name("stored_qty"),
  lastAccrueAt: __t.timestamp().name("last_accrue_at"),
});
